import { render, staticRenderFns } from "./Sandbox.vue?vue&type=template&id=2a5a4e89&"
import script from "./Sandbox.vue?vue&type=script&lang=js&"
export * from "./Sandbox.vue?vue&type=script&lang=js&"
import style0 from "./Sandbox.vue?vue&type=style&index=0&id=2a5a4e89&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports